export default __webpack_public_path__ + "static/media/contact.7d85e553.jpg";